import React, { useEffect, useState } from 'react'
// import './dashboard.css'
import './adminpanel.css'
import { useAuthContext } from '../../Hooks/useAuthContext'
import axios from 'axios'
import { FaAlignLeft, FaSignOutAlt, FaTimes, FaUserAlt } from 'react-icons/fa'
import { toast } from 'wc-toast'
import AdminConfirm from './AdminConfirm'
import { Link, useNavigate } from 'react-router-dom'
import AdminSidebar from './AdminSideBar'
import Loader from '../../Component/Loader/Loader'

function formatMongoDate(mongoDate) {
  const d = new Date(mongoDate)
  const day  = String(d.getDate()).padStart(2, '0')
  const mon  = String(d.getMonth() + 1).padStart(2, '0')
  const yr   = String(d.getFullYear()).slice(-2)
  const hr   = String(d.getHours())
  const min  = String(d.getMinutes()).padStart(2, '0')
  return `${day}/${mon}/${yr} ${hr}:${min}`
}

function Tickets() {
  const navigate                              = useNavigate()
  const { user, dispatch }                    = useAuthContext()
  const [sidemenu, setSideMenu]               = useState(false)
  const [shouldMenuSlide, setShouldMenuSlide] = useState(false)
  const [dashUser, setDashUser]               = useState(false)
  const [data, setData]                       = useState([])
  const [edit, setEdit]                       = useState(false)
  const [ticketId, setTicketId]               = useState(null)
  const [confirm, setConfirm]                 = useState(false)
  const [updateDelete, setUpdateDelete]       = useState(null)
  const [loading, setLoading]                 = useState(true)
  const [formData, setFormData]               = useState({ message: '', subject: '', email: '' })

  /* Auth guard */
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/isadmin`, {
      headers: { Authorization: `Bearer ${user.token}` },
    }).then(r => {
      if (r.data.admin)     { /* ok */ }
      else if (r.data.user) navigate('/admin-panel')
      else                  navigate('/')
    }).catch(e => console.log(e))
  }, [user.token])

  /* Fetch tickets */
  useEffect(() => {
    const fetchData = async () => {
      try {
        const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/tickets`, {
          headers: { Authorization: `Bearer ${user.token}` },
        })
        setData(r.data)
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [user.token, updateDelete])

  const logout = () => {
    dispatch({ type: 'LOGOUT', payload: null })
    setTimeout(() => navigate('/rf-admin'), 3000)
  }

  const handleChange    = (e) => setFormData(p => ({ ...p, [e.target.id]: e.target.value }))
  const handleEditClick = (d)  => { setEdit(true); setFormData({ message: d.message, subject: d.subject, email: d.email }) }
  const handleDelete    = (id) => { setTicketId(id); setConfirm(true) }
  const onCancel        = ()   => setConfirm(false)

  const onConfirm = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/admin/delete-ticket/${ticketId}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      toast.success('Deleted Successfully')
      setConfirm(false)
      setUpdateDelete(ticketId)
    } catch (e) { console.log(e) }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    // submit logic here
  }

  return (
    <div className="admin dashboard">

      {/* ── Header ──────────────────────────────────────── */}
      <div className="dashboard-header">
        <div className="rights-side">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <p>{process.env.REACT_APP_APP_NAME}<span className="admin-badge">Admin</span></p>
          </Link>
          <FaAlignLeft size={18} onClick={() => { setShouldMenuSlide(true); setSideMenu(!sidemenu) }} />
        </div>
        <div className="left-side">
          <div className="dh-avatar" onClick={() => setDashUser(p => !p)}><FaUserAlt size={14} /></div>
          {dashUser && (
            <div className="user-menu">
              <p className="logout" onClick={logout}><FaSignOutAlt size={13} /> Logout</p>
            </div>
          )}
        </div>
      </div>

      {/* ── Sidebar ─────────────────────────────────────── */}
      {sidemenu && <AdminSidebar shouldMenuSlide={shouldMenuSlide} onClose={() => setSideMenu(false)} />}

      {/* ── Body ─────────────────────────────────────────── */}
      <div className="dashboard-main-section">
        <div className="loan-container">
          <div className="table-head">
            <div>
              <div className="db-breadcrumb">Admin &nbsp;/&nbsp; <span>Tickets</span></div>
              <h2>Tickets</h2>
            </div>
          </div>

          {loading ? <Loader /> : (
            <div className="db-card">
              <div className="db-card__bar" />
              <div className="loan-table">
                <table className="equal-table">
                  <thead>
                    <tr>
                      <th>Subject</th>
                      <th>Sender Email</th>
                      <th>Created At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? data.map(ticket => (
                      <tr key={ticket._id}>
                        <td>{ticket.subject}</td>
                        <td>{ticket.userEmail}</td>
                        <td>{formatMongoDate(ticket.createdAt)}</td>
                        <td>
                          <div className="action-tb">
                            <button className="db-btn db-btn--ghost db-btn--sm" onClick={() => handleEditClick(ticket)}>Open</button>
                            <button className="db-btn db-btn--danger db-btn--sm" onClick={() => handleDelete(ticket._id)}>Delete</button>
                          </div>
                        </td>
                      </tr>
                    )) : (
                      <tr><td colSpan="4" className="no-loan-message">No Tickets</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ── View ticket overlay ──────────────────────────── */}
      {edit && (
        <div className="deposits-form">
          <button className="wd-close" onClick={() => setEdit(false)} aria-label="Close"><FaTimes size={14} /></button>
          <div className="send-money-container" style={{ width: '100%', maxWidth: '560px' }}>
            <form className="send-money-form" onSubmit={handleSubmit}>
              <h2>Ticket Details</h2>
              <div className="send-money-grid">
                <div className="send-money-form-group">
                  <label htmlFor="subject">Subject</label>
                  <input type="text" id="subject" value={formData.subject || ''} onChange={handleChange} />
                </div>
              </div>
              <div className="send-money-grid">
                <div className="send-money-form-group">
                  <label htmlFor="email">Email</label>
                  <input type="text" id="email" value={formData.email || ''} onChange={handleChange} />
                </div>
              </div>
              <div className="send-money-grid">
                <div className="send-money-form-group">
                  <label htmlFor="message">Message</label>
                  <textarea id="message" value={formData.message || ''} onChange={handleChange} rows={5} />
                </div>
              </div>
              <div style={{ padding: '0 2rem' }}>
                <button type="submit" className="send-money-send-btn">Submit →</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {confirm && <AdminConfirm message="Are you sure you want to delete?" onConfirm={onConfirm} onCancel={onCancel} />}
    </div>
  )
}

export default Tickets